import { render, staticRenderFns } from "./RespondList.vue?vue&type=template&id=18375583&"
import script from "./RespondList.vue?vue&type=script&lang=js&"
export * from "./RespondList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports